<button class="lv-tertiary-button-default" mat-button (click)="clickEvent.emit($event)">
  <mat-icon [svgIcon]="icon"></mat-icon>
  <span class="lv-tertiary-button-text" [innerHTML]="label"></span>
</button>
